import React from 'react'
interface Props {
  styleCssImage: string

}
const LogoAssurence: React.FC<Props> = ({
  styleCssImage
}) => {
  return (
    // fill-[#FF76C8]
    <svg 
    className={`${styleCssImage} fill-[#FF76C8] `}
    width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.9996" height="60" rx="10" 

      // fill="#FF76C8" 
      />
      <path
        d="M42.1478 33.4309H38.658C38.2292 33.4309 37.8065 33.5275 37.4231 33.7128L34.4476 35.1519C34.0642 35.3372 33.6415 35.4336 33.2127 35.4336H31.6934C30.224 35.4336 29.0327 36.5859 29.0327 38.0072C29.0327 38.0645 29.0721 38.1151 29.1291 38.1308L32.8318 39.1541C33.4961 39.3376 34.2073 39.2737 34.8252 38.9748L38.0061 37.4367M29.0327 37.0721L22.3399 35.0168C21.1535 34.6473 19.8709 35.0854 19.1277 36.1141C18.5903 36.8578 18.8091 37.923 19.592 38.3745L30.544 44.6903C31.2405 45.0919 32.0624 45.1899 32.8284 44.9627L42.1478 42.1987"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.7904 23.2824V20.9539C37.7904 19.6385 37.7904 18.9808 37.463 18.5517C37.1356 18.1226 36.3953 17.9143 34.9148 17.4976C33.9033 17.213 33.0116 16.87 32.2992 16.5569C31.3278 16.1301 30.8422 15.9166 30.4987 15.9166C30.1552 15.9166 29.6696 16.1301 28.6982 16.5569C27.9858 16.87 27.0942 17.2129 26.0826 17.4976C24.6021 17.9143 23.8618 18.1226 23.5344 18.5517C23.207 18.9808 23.207 19.6385 23.207 20.9539V23.2824C23.207 27.7943 27.3088 30.5013 29.3596 31.5728C29.8514 31.8298 30.0973 31.9583 30.4987 31.9583C30.9001 31.9583 31.146 31.8298 31.6378 31.5728C33.6886 30.5013 37.7904 27.7943 37.7904 23.2824Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default LogoAssurence
